import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"

import { faCircleArrowDown, faDeleteLeft, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons"
import { Link, useNavigate } from "react-router-dom"
import Backdrop from "../../../Backdrop"
import InfoIcon from "../../../InfoIcon"
import Filter from "./mobile/filter"
import useFetch from "../../../../hook/useFetch"
import { notificationActions } from "../../../../store/notification-slice"

export default function MobileComponent() {


    const [mobileItems, setMobileItems] = useState()


    let filteredlogs = useSelector((state) => state.log.filteredlogs)

    let dispatch = useDispatch()



    let statelogs = useSelector(state => state.log.logs)


    useEffect(() => {

        let items = []
        let logs = filteredlogs ?? statelogs

        if (logs && Object.keys(logs).length > 0) {

            logs.forEach((log) => {

                items.push(<MobileItem key={log.id} log={log} />)

            })
        }
        setMobileItems(items)



    }, [filteredlogs, statelogs])


    if (!mobileItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            {mobileItems}
        </Filter>
        <Backdrop />
    </Fragment>
}


function MobileItem(props) {
    const { log } = props

    const [showContent, setShowContent] = useState(false)

    let user = useSelector(state => state.user.user)
    let link = user.id === log.user_id ? '/admin/profile' : `/admin/users/${log.user_id}`

    

    let dispatch = useDispatch()

    let navigate = useNavigate()

    const { del } = useFetch()

    return <Fragment>

        <div className="card shadow  bg-white rounded p-3" style={{ cursor: 'pointer' }} onClick={() => {
            setShowContent(!showContent)
        }}  >
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }} >
                <span>{log.id}</span>
                <span>{log.method}</span>
                <span>{log.user_id}</span>

            </div>
            <InfoIcon icon={faCircleArrowDown} size='xl' />

        </div>
        {showContent &&
            <table className="table table-striped table-bordered" >
                <tbody>
                    <tr>
                        <th>ID</th>
                        <td>
                            {log.id}
                        </td>
                    </tr>
                    <tr>
                        <th>Method</th>

                        <td>
                            {log.method}
                        </td>
                    </tr>
                    <tr>
                        <th>Email</th>
                        <td>
                            <Link to={link} >{log.email}</Link>
                        </td>
                    </tr>
                    <tr>
                        <th>CreatedOn</th>
                        <td>
                            {log.created_on}
                        </td>
                    </tr>

                    <tr>

                        <th>Delete</th>
                        <td>
                            <button type="button" className="btn btn-outline-secondary bgnt" onClick={() => {
                                del(`/admin/log`, { id: log.id }, (data) => {
                                    dispatch(notificationActions.setNotification({
                                        message: data,
                                        status: false
                                    }))
                                },
                                    () => {
                                        dispatch(notificationActions.setNotification({
                                            message: `log deleted`,
                                            status: true
                                        }))


                                        navigate('/admin/logs', {
                                            state: {
                                                refetch: true
                                            }
                                        })
                                    }
                                )
                            }} ><InfoIcon icon={faTrash} title='delete log' /></button>
                        </td>

                    </tr>

                </tbody>
            </table>
        }


    </Fragment>

}